import { usePlayer as useReactPlayer } from '@landr/react-player';
import { StreamEntityType } from 'types/enums';
import { PACK_STREAM_QUERY } from 'apollo/pack/pack.gql';
import { REPACK_STREAM_QUERY } from 'apollo/repack/repack.gql';
import { SAMPLE_STREAM_QUERY } from 'apollo/sample';
import { DocumentNode } from 'graphql';

export type PlayerInstance = ReturnType<typeof useReactPlayer>;

export interface UsePlayerType {
    currentTime: number;
    loading: boolean;
    playing: boolean;
    totalTime: number;
    togglePlaying: () => void;
    playFromBeginning: () => void;
    seek: (value: number, playOnSeek?: boolean | undefined) => void;
}

export const ApiResponses: { [key in StreamEntityType]: string } = {
    [StreamEntityType.Packs]: 'packStream',
    [StreamEntityType.Repacks]: 'repackStream',
    [StreamEntityType.Samples]: 'sampleStream',
};

export const ApiQueries: { [key in StreamEntityType]: DocumentNode } = {
    [StreamEntityType.Packs]: PACK_STREAM_QUERY,
    [StreamEntityType.Repacks]: REPACK_STREAM_QUERY,
    [StreamEntityType.Samples]: SAMPLE_STREAM_QUERY,
};

export const ApiQueryVariables: { [key in StreamEntityType]: string } = {
    [StreamEntityType.Packs]: 'packGuid',
    [StreamEntityType.Repacks]: 'repackGuid',
    [StreamEntityType.Samples]: 'sampleGuid',
};
